'use strict'
import {bootstrap} from '../bootstrap/bootstrap'
import {initializeChart} from '../glyphs/initialize'

export function stepBodyMovinAnimations(animationName, bmAnimation, animationSegments, step) {
  if (bmAnimation !== null && animationName !== '') {
    bmAnimation.playSegments(animationSegments[animationName][step - 1], true)
  }
}

export function stepGylphAnimationCharts(glyphAnimationSegments, step) {
  const glyphChart = glyphAnimationSegments[step - 1]
  const newClassList = `half half--visualization glyph-chart ${glyphChart.class}`
  const visualizationContainer = this.querySelector('.half--visualization')
  const charts = Array.from(visualizationContainer.getElementsByTagName('svg'))

  charts.forEach(chart => chart.remove())
  visualizationContainer.classList = newClassList
  bootstrap(visualizationContainer, initializeChart, ...glyphChart.configuration)
}
